import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Admin = Firebase custom claim admin === true (verified in AuthContext; exposed as currentUser.isAdmin).
const AdminRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  if (loading) return <div>Loading...</div>;
  if (!currentUser || currentUser.isAdmin !== true) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default AdminRoute;
